<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Prodigal Daughter</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<p class="image-title"><img alt="map.jpg" src="images/map.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_prechap_04.vue?d3205fb0